
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cocktayl-pro",
      function () {
        return require("private-next-pages/cocktayl-pro.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cocktayl-pro"])
      });
    }
  